<template>
  <el-card class="box-card" ref="card" shadow="never">
    <div class="d-flex-row justify-content-between">
      <span style="font-size: 18px;font-weight: bold;">客单区间</span>
      <el-link type="primary" icon="el-icon-refresh" @click="getData">刷新</el-link>
    </div>
    <el-row>
      <el-col :span="8">
        <h3>{{ year }}年客单区间</h3>
        <el-table class="dashboard-table"
                  show-summary
                  :summary-method="getSummaries"
                  :data="dataTable"
                  style="width: 100%">
          <el-table-column prop="passenger_order_interval" label="客单区间" align="center"/>
          <el-table-column prop="order_count" label="订单数（单）" align="right"/>
          <el-table-column prop="order_money" label="订单金额（元）" align="right">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_percent_count" label="单量占比（%）" align="right">
            <template slot-scope="scope">
              <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_count, 1) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_percent_money" label="金额占比（%）" align="right">
            <template slot-scope="scope">
              <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_money, 1) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="8">
        <h3>{{ year }}年客单区间-单量占比</h3>
        <div id="customerPerPriceCount" style="width: 100%;height: 300px"/>
      </el-col>
      <el-col :span="8">
        <h3>{{ year }}年客单区间-金额占比</h3>
        <div id="customerPerPriceMoney" style="width: 100%;height: 300px"/>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import {customerPrePrice} from "../../../api/dashboard";
import * as echarts from 'echarts';

export default {
  name: "CustomerPerPrice",
  props: {
    //是否限制范围
    isScope:{
      type:Boolean,
      default() {
        return false;
      }
    },
    year: [Number, String],
    artistId: {
      type: [Number, String],
      default: 0
    },
    customerId: {
      type: [Number, String],
      default: 0
    },
    keyCustomerId: {
      type: [Number, String],
      default: 0
    },
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
  },
  data() {
    return {
      queryYear: this.year,
      dataTable: [],
    }
  },
  created() {
    this.getData()
  },
  watch: {
    year: function (value) {
      this.queryYear = value;
      this.getData()
    },
    artistId: function () {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.data = [];
      customerPrePrice({
        organization_id: this.organizationId,
        year: this.queryYear,
        artist_id: this.artistId,
        customer_id: this.customerId,
        key_customer_id: this.keyCustomerId,
        //显示数据范围：仅当前用户
        user_id: this.user.id
      }).then(res => {
        this.dataTable = res.model.data;
        this.total_count = res.model.total_count;
        this.total_money = res.model.total_money;
        let countArr = [];
        let moneyArr = [];
        for (let i = 0; i < this.dataTable.length; i++) {
          const obj = this.dataTable[i]
          countArr.push({name: obj.passenger_order_interval, value: obj.order_count});
          moneyArr.push({name: obj.passenger_order_interval, value: obj.order_money})
        }
        this.$nextTick(function () {
          setTimeout(() => {
            this.initChart('customerPerPriceCount', countArr);
            this.initChart('customerPerPriceMoney', moneyArr)
          }, 500);
        });
      })
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:';
          return
        }
        if (['order_count', 'order_money', 'order_percent_count', 'order_percent_money'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
    initChart(domId, data) {
      if (data.length < 1) {
        return;
      }
      const myChart = echarts.init(document.getElementById(domId));
      let option;
      option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: '客单区间',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '17',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      option && myChart.setOption(option);
    },
  }
}
</script>

<style>

</style>
